import XSelect from '../../../components/common/XSelect';
import XCheckbox from '../../../components/common/XCheckbox';
import XModal from '../../../components/common/XModal';
import { fontFamilyOptions, fontSizeOptions } from '../../../utils/constant';
import { textAlignOptions } from '@demandproai/shared';
import { useTemplateContext } from '../context/TemplateContext';

const formWrapperClasses = 'grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-4';
const formGroupClasses = 'relative';
const fullColumnClasses = 'md:col-span-2';
const inputGroupClasses = 'flex flex-col';
const labelClasses = 'mb-2 text-sm font-normal text-content';
const inputClasses =
    'mt-auto block w-full rounded border border-border bg-white px-3 py-1.5 ' +
    'text-base font-normal text-content outline-none ' +
    'focus:border-primary-tint focus:ring-4 focus:ring-primary/25';
const spacingSectionClasses = 'md:col-span-2 mb-2';
const checkboxRowClasses = 'md:col-span-2 flex flex-wrap gap-6 mb-3';

const TemplateFormattingSettingModal = () => {
    const {
        templateData,
        onChangeFontFamily,
        fontFamily,
        onChangeAmoutText,
        onChangeFontSize,
        onChangeTextAlign,
        onChangeIsItalic,
        onChangeIsBold,
        onChangeParagraphSpacingBefore,
        onChangeParagraphSpacingAfter,
        onChangeBulletSpacingBefore,
        onChangeBulletSpacingAfter,
        onChangeParagraphIndentation,
        setTemplateFormattingModalOpen
    } = useTemplateContext();

    if (templateData.billedAmountHeading == null) {
        templateData.billedAmountHeading = true;
    }

    return (
        <XModal
            isOpen={true}
            title="Template Formatting Settings"
            onClose={() => setTemplateFormattingModalOpen(false)}
            size="lg"
        >
            <div className={formWrapperClasses}>
                <div className={formGroupClasses}>
                    <XSelect
                        emptyOption={false}
                        label="Font Family"
                        value={fontFamily}
                        onChange={onChangeFontFamily}
                        options={fontFamilyOptions}
                        isCommon={true}
                    />
                </div>

                <div className={formGroupClasses}>
                    <XSelect
                        emptyOption={false}
                        label="Font Size"
                        value={templateData?.fontSize}
                        onChange={onChangeFontSize}
                        options={fontSizeOptions}
                        isCommon={true}
                    />
                </div>

                <div className={`${formGroupClasses} ${fullColumnClasses}`}>
                    <XSelect
                        emptyOption={false}
                        label="Paragraph Alignment"
                        value={templateData?.textAlign}
                        onChange={onChangeTextAlign}
                        options={textAlignOptions}
                        isCommon={true}
                    />
                </div>

                <div className={spacingSectionClasses}>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-4">
                        <div className={inputGroupClasses}>
                            <label
                                className={labelClasses}
                                htmlFor="paragraphSpacingBefore"
                            >
                                Before Paragraph Spacing (pt)
                            </label>
                            <input
                                type="number"
                                className={inputClasses}
                                id="paragraphSpacingBefore"
                                value={templateData?.paragraphSpacingBefore || 120}
                                onChange={onChangeParagraphSpacingBefore}
                                min="0"
                                step="1"
                            />
                        </div>

                        <div className={inputGroupClasses}>
                            <label
                                className={labelClasses}
                                htmlFor="paragraphSpacingAfter"
                            >
                                After Paragraph Spacing (pt)
                            </label>
                            <input
                                type="number"
                                className={inputClasses}
                                id="paragraphSpacingAfter"
                                value={templateData?.paragraphSpacingAfter || 120}
                                onChange={onChangeParagraphSpacingAfter}
                                min="0"
                                step="1"
                            />
                        </div>
                    </div>
                </div>

                <div className={spacingSectionClasses}>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-4">
                        <div className={inputGroupClasses}>
                            <label
                                className={labelClasses}
                                htmlFor="bulletSpacingBefore"
                            >
                                Before Bullet Point Spacing (pt)
                            </label>
                            <input
                                type="number"
                                className={inputClasses}
                                id="bulletSpacingBefore"
                                value={templateData?.bulletSpacingBefore || 10}
                                onChange={onChangeBulletSpacingBefore}
                                min="0"
                                step="1"
                            />
                        </div>

                        <div className={inputGroupClasses}>
                            <label
                                className={labelClasses}
                                htmlFor="bulletSpacingAfter"
                            >
                                After Bullet Point Spacing (pt)
                            </label>
                            <input
                                type="number"
                                className={inputClasses}
                                id="bulletSpacingAfter"
                                value={templateData?.bulletSpacingAfter || 10}
                                onChange={onChangeBulletSpacingAfter}
                                min="0"
                                step="1"
                            />
                        </div>
                    </div>
                </div>

                <div className={checkboxRowClasses}>
                    <XCheckbox
                        name="isParagraphIndentation"
                        label="Indentation"
                        checked={templateData.isParagraphIndentation}
                        onChange={onChangeParagraphIndentation}
                    />
                    <XCheckbox
                        name="isBold"
                        label="Bold"
                        checked={templateData.isBold}
                        onChange={onChangeIsBold}
                    />
                    <XCheckbox
                        name="isItalic"
                        label="Italic"
                        checked={templateData.isItalic}
                        onChange={onChangeIsItalic}
                    />
                </div>

                <div className={fullColumnClasses}>
                    <XCheckbox
                        name="billedAmountHeading"
                        label="Display Howell Amount as Billed Amount"
                        checked={templateData.billedAmountHeading}
                        onChange={onChangeAmoutText}
                    />
                </div>
            </div>
        </XModal>
    );
};

export default TemplateFormattingSettingModal